import React, { useState } from 'react'
import Catalog from 'blocks.app/catalog/catalog'
import { EXHIBITIONS_PAGES_CATALOG_CONFIG, ExhibitionSelectedItems } from '../InstancesCatalogExhibition-types'

export const InstancesCatalogExhibitionsPages = () => {
    const [selectedItems, setSelectedItems] = useState<ExhibitionSelectedItems>([])

    return (
        <Catalog
            type={EXHIBITIONS_PAGES_CATALOG_CONFIG.type}
            onSelect={setSelectedItems}
            selectedItems={selectedItems}
            treeView={EXHIBITIONS_PAGES_CATALOG_CONFIG.treeView}
            additionalData={EXHIBITIONS_PAGES_CATALOG_CONFIG.additionalData}
            fixedHeader={EXHIBITIONS_PAGES_CATALOG_CONFIG.fixedHeader}
            isExistRightToolbar={EXHIBITIONS_PAGES_CATALOG_CONFIG.isExistRightToolbar}
            hideHeader={EXHIBITIONS_PAGES_CATALOG_CONFIG.hideHeader}
        />
    )
}
